<po-page-default
  p-title="Movimentações - Importação de Dados"
  p-subtitle="Importe planilhas para realizar as movimentações."
  [p-breadcrumb]="breadcrumb">

  <div class="page-summary">
    <div class="page-summary-icon">
      <i class="an an-arrows-clockwise"></i>
    </div>
    <div class="page-summary-text">
      <p class="po-font-subtitle po-mb-0">Importação de movimentações periódicas</p>
      <p class="page-summary-hint">Selecione arquivos <b>.xlsx</b> ou <b>.csv</b> seguindo as orientações abaixo. Múltiplos arquivos podem ser enviados simultaneamente.</p>
    </div>
  </div>

  <po-divider></po-divider>

  <!-- Seção: Orientações -->
  <div class="ci-section po-mt-3">
    <div class="ci-section-header">
      <i class="an an-info"></i>
      <span>Orientações</span>
    </div>
    <div class="ci-section-body">
      <p class="po-font-text-large-bold po-mb-2">
        O arquivo deve estar no formato <strong>XLSX</strong> ou <strong>CSV</strong> e seguir as regras:
      </p>
      <div class="ci-rules">
        <div class="ci-rule">
          <i class="an an-check-circle"></i>
          <span>Conter as colunas obrigatórias para cada tipo de movimentação.</span>
        </div>
        <div class="ci-rule">
          <i class="an an-check-circle"></i>
          <span>As colunas devem estar na ordem correta, conforme a documentação.</span>
        </div>
        <div class="ci-rule">
          <i class="an an-check-circle"></i>
          <span>Dados formatados corretamente, sem erros de digitação.</span>
        </div>
        <div class="ci-rule">
          <i class="an an-check-circle"></i>
          <span>Nome do arquivo deve conter o código da tabela, com ou sem colchetes: <b>[JC83XX]</b> ou <b>JC83XX</b>.</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Seção: Códigos disponíveis -->
  <div class="ci-section po-mt-3">
    <div class="ci-section-header">
      <i class="an an-list-bullets"></i>
      <span>Movimentações Disponíveis</span>
    </div>
    <div class="ci-section-body">
      <p class="po-font-text po-mb-2">Após a importação, verifique se os dados foram inseridos corretamente.</p>
      <div class="ci-codes-grid">
        <div class="ci-code-item">
          <span class="ci-code-badge">JC8304</span>
          <span class="ci-code-label">Despachos</span>
        </div>
        <div class="ci-code-item">
          <span class="ci-code-badge">JC8306</span>
          <span class="ci-code-label">Notas Fiscais</span>
        </div>
        <div class="ci-code-item">
          <span class="ci-code-badge">JC8307</span>
          <span class="ci-code-label">Ajustes de Estoque</span>
        </div>
        <div class="ci-code-item">
          <span class="ci-code-badge">JC8308</span>
          <span class="ci-code-label">Rateios de Energia</span>
        </div>
        <div class="ci-code-item">
          <span class="ci-code-badge">JC8309</span>
          <span class="ci-code-label">Ordens de Produção</span>
        </div>
        <div class="ci-code-item">
          <span class="ci-code-badge">JC8311</span>
          <span class="ci-code-label">Devoluções</span>
        </div>
        <div class="ci-code-item">
          <span class="ci-code-badge">JC8314</span>
          <span class="ci-code-label">Transferência de Fichas</span>
        </div>
        <div class="ci-code-item">
          <span class="ci-code-badge">JC8315</span>
          <span class="ci-code-label">Ordens Prod. Outros Estab.</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Seção: Upload -->
  <div class="ci-section po-mt-3 po-mb-4">
    <div class="ci-section-header">
      <i class="an an-upload-simple"></i>
      <span>Enviar Arquivos</span>
    </div>
    <div class="ci-section-body">
      <app-component-importacao [rotas]="rotas"/>
    </div>
  </div>

</po-page-default>
